// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useRef} from 'react';
import {Editor} from '../../../shared/editor/editor';
import {use_theme} from '../settings_ctx';
import {use_screen} from '../lib/screen_util';
import {use_section_scroll} from '../lib/use_section_scroll';
import {i_media_block_props, Media_block} from '../ui/media_block';
import styles from './access_for_all_banner.module.less';


const Access_for_all_block = (props: i_media_block_props)=>{
    const ref = useRef();
    use_section_scroll(ref, false);
    return <Media_block ref={ref} {...props}/>;
};

export const Access_for_all = ()=>{
    const {width} = use_screen();
    const is_mobile = width < 768;
    const {theme} = use_theme();
    let democracy = 'about/democracy.svg';
    let borderless = 'about/borderless.svg';
    if (is_mobile)
    {
        democracy = 'about/democracy_mobile.svg';
        borderless = 'about/borderless_mobile.svg';
    }
    const media: i_media_block_props[] = [
        {
            img: democracy,
            title: 'Hola believes in Online Democracy',
            text: `The team behind Hola is driven by Innovation, Online
                Democracy and Internet Freedom. We believe in Worldwide Online
                Access for All.`,
            reversed: false,
            cls: {container: styles.access_for_all_block, img: styles.img,
                text: theme.p2},
        },
        {
            img: borderless,
            title: 'We are committed to creating a Borderless Internet.',
            text: `Think of Hola as your passport that gets you visa-free
                Online Access to truly Worldwide content. This is our ultimate
                destination.`,
            reversed: true,
            cls: {container: styles.access_for_all_block, img: styles.img,
                text: theme.p2},
        },
    ];
    return <section className={styles.access_for_all_section}>
      {media.map(props=><Access_for_all_block key={props.img} {...props}/>)}
    </section>;
};

interface i_access_for_all_editor_props {
    value: never;
    on_change: (new_val: never)=>void;
}

export const Access_for_all_editor = (
{value, on_change}: i_access_for_all_editor_props
)=>{
    return <Editor value={value} on_change={on_change} editors={[]}/>;
};
